export default __webpack_public_path__ + "static/media/Нэгдсэн уулзалт төсвийн шинэчлэл, боловсролын салбарын бодлого, эрх зүйн шинэчлэл.67506f0b.pdf";